import { __rest, __assign } from 'tslib';
import React, { forwardRef, useRef, useEffect } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { Skeleton } from '../../../../skeleton/esm';

var Title = forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var id = _a.id, toggleClassName = _a.toggleClassName, title = _a.title, _e = _a.styles, styles = _e === void 0 ? {} : _e, _f = _a.rightAddons, rightAddons = _f === void 0 ? null : _f, _g = _a.hidden, hidden = _g === void 0 ? false : _g, _h = _a.selected, selected = _h === void 0 ? false : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, _k = _a.collapsed, collapsed = _k === void 0 ? false : _k, _l = _a.focused, focused = _l === void 0 ? false : _l, _m = _a.isOption, isOption = _m === void 0 ? false : _m, _o = _a.showSkeleton, showSkeleton = _o === void 0 ? false : _o, skeletonProps = _a.skeletonProps, onResize = _a.onResize, dataTestId = _a.dataTestId, restProps = __rest(_a, ["id", "toggleClassName", "title", "styles", "rightAddons", "hidden", "selected", "disabled", "collapsed", "focused", "isOption", "showSkeleton", "skeletonProps", "onResize", "dataTestId"]);
    var buttonRef = useRef(null);
    var titleClassName = (_b = {},
        _b[styles.content] = true,
        _b[styles.focused] = focused,
        _b);
    useEffect(function () {
        var resizeObserver = new ResizeObserver(function () {
            if (onResize) {
                onResize();
            }
        });
        var button = buttonRef.current;
        if (button) {
            resizeObserver.observe(button);
        }
        return function () {
            if (button) {
                resizeObserver.unobserve(button);
            }
        };
    }, [onResize]);
    return hidden ? null : (React.createElement("button", __assign({}, restProps, { "data-test-id": dataTestId, ref: mergeRefs([ref, buttonRef]), disabled: disabled || showSkeleton, type: 'button', id: String(id), className: cn(styles.title, (_c = {},
            _c[styles.selected] = selected,
            _c[styles.disabled] = disabled,
            _c[styles.collapsed] = collapsed && !isOption,
            _c[styles.option] = isOption,
            _c), toggleClassName) }),
        showSkeleton ? (React.createElement(Skeleton, __assign({}, skeletonProps, { className: cn(titleClassName, skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.className), visible: true }), title)) : (React.createElement("span", { className: cn(titleClassName) }, title)),
        rightAddons && (React.createElement("span", { className: cn(styles.rightAddons, (_d = {},
                _d[styles.rightAddonsMarginZero] = !title,
                _d)) }, rightAddons))));
});

export { Title };
